import React from "react";
import { withNamespace } from "components/Form/FormikControls";
import { FormCollapse } from "components/Form";
import { EmailRecipientsTable } from "./EmailRecipientsTable";
import { EmailRecipientsHeader } from "./EmailRecipientsHeader";

interface EmailRecipientsPanelProps {
  businessId: string;
  isOpen: boolean;
  namespace?: string;
  onSetPrimaryContactEmail: (email: string) => void;
  onToggle: () => void;
  primaryContactEmail: string | null;
}

export function EmailRecipientsPanel({
  businessId,
  isOpen,
  namespace,
  onSetPrimaryContactEmail,
  onToggle,
  primaryContactEmail,
}: EmailRecipientsPanelProps): React.JSX.Element {
  const ns = withNamespace(namespace, "emailRecipients");

  return (
    <FormCollapse
      dataTour="emailCollapse"
      header={
        <EmailRecipientsHeader
          namespace={ns}
          primaryContactEmail={primaryContactEmail}
        />
      }
      id={ns}
      isOpen={isOpen}
      onToggle={onToggle}
    >
      <EmailRecipientsTable
        businessId={businessId}
        namespace={ns}
        onSetPrimaryContactEmail={onSetPrimaryContactEmail}
        primaryContactEmail={primaryContactEmail}
      />
    </FormCollapse>
  );
}
